export default `---
slug: morocco
country: Morocco
countryCode: MAR
continent: Africa
year: 2020
title: "Morocco"
description: "Marrakech, the Sahara, and sensory overload in the best possible way."
thumbnail: /images/travels/MAR/morocco_thumb.jpg
relatedLinks: []
---
![morocco](/images/travels/MAR/morocco_thumb.jpg)

*Story coming soon — stay tuned!*

I visited Morocco and it was an incredible experience. Full story and photos are being written up and will appear here soon.
`;
